import {
  INSTALLER_COMPANIES_START,
  INSTALLER_COMPANIES_ERROR,
  INSTALLER_COMPANIES_SUCCESS,
  INSTALLER_COMPANY_ADD_START,
  INSTALLER_COMPANY_ADD_ERROR,
  INSTALLER_COMPANY_ADD_SUCCESS,
  INSTALLER_COMPANY_UPDATE_START,
  INSTALLER_COMPANY_UPDATE_ERROR,
  INSTALLER_COMPANY_UPDATE_SUCCESS,
  INSTALLER_COMPANY_PASSWORD_START,
  INSTALLER_COMPANY_PASSWORD_SUCCESS,
  INSTALLER_COMPANY_PASSWORD_ERROR,
  COMMERCIAL_OFFERS_START,
  COMMERCIAL_OFFERS_SUCCESS,
  COMMERCIAL_OFFERS_ERROR,
  FILTER_SHOP_START,
  FILTER_SHOP_SUCCESS,
  FILTER_SHOP_ERROR,
  COMMERCIAL_OFFER_SAVE_START,
  COMMERCIAL_OFFER_SAVE_ERROR,
  COMMERCIAL_OFFER_SAVE_SUCCESS,
  FILTER_SHOP_SAVE_START,
  FILTER_SHOP_SAVE_ERROR,
  FILTER_SHOP_SAVE_SUCCESS,
  INSTALLER_COMPANY_DISABLE_START,
  INSTALLER_COMPANY_DISABLE_SUCCESS,
  INSTALLER_COMPANY_DISABLE_ERROR,
  PRODUCTS_START,
  PRODUCTS_SUCCESS,
  PRODUCTS_ERROR,
  PRODUCT_ADD_START,
  PRODUCT_ADD_ERROR,
  PRODUCT_ADD_SUCCESS,
  PRODUCT_UPDATE_START,
  PRODUCT_UPDATE_ERROR,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_DISABLE_START,
  PRODUCT_DISABLE_SUCCESS,
  PRODUCT_DISABLE_ERROR,
  SOFTWAREVERSIONS_START,
  SOFTWAREVERSIONS_ERROR,
  SOFTWAREVERSIONS_SUCCESS,
  SOFTWAREVERSION_ADD_START,
  SOFTWAREVERSION_ADD_ERROR,
  SOFTWAREVERSION_ADD_SUCCESS,
  SOFTWAREVERSION_DELETE_START,
  SOFTWAREVERSION_DELETE_ERROR,
  SOFTWAREVERSION_DELETE_SUCCESS,
  SOFTWAREVERSION_UPDATE_START,
  SOFTWAREVERSION_UPDATE_SUCCESS,
  SOFTWAREVERSION_UPDATE_ERROR,
  UPLOAD_START,
  UPLOAD_ERROR,
  UPLOAD_SUCCESS,
  LOAD_MANAGER_START,
  LOAD_MANAGER_SUCCESS,
  LOAD_MANAGER_ERROR,
  LOAD_DOCUMENTS_START,
  LOAD_DOCUMENTS_SUCCESS,
  LOAD_DOCUMENTS_ERROR,
  CHANGE_DOCUMENT_POSITION_START,
  CHANGE_DOCUMENT_POSITION_SUCCESS,
  CHANGE_DOCUMENT_POSITION_ERROR,
  DOCUMENT_ADD_START,
  DOCUMENT_ADD_SUCCESS,
  DOCUMENT_ADD_ERROR,
  DOCUMENT_DELETE_START,
  DOCUMENT_DELETE_ERROR,
  DOCUMENT_DELETE_SUCCESS,
  CHANGE_TAB
} from '../constants/Constants.js';
import api from '../api';
import messages from '../messages';

let strings = messages.getLocalizedStrings();

function getErrorMsg(msgList, path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(msgList[location[0]], location.slice(1));
  }
  return msgList[path];
}

function getErrorMessage(path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(strings.error[location[0]], location.slice(1));
  }
  return strings.error[path];
}

export function loadInstallerCompanies() {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANIES_START
    });

    api.loadInstallerCompanies(function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANIES_ERROR,
            text: getErrorMessage('installer-company.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANIES_ERROR,
            text: getErrorMessage('installer-company.load-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let installerCompanies = [];
        if (res.body && res.body._embedded && res.body._embedded.installerCompanies) {
          installerCompanies = res.body._embedded.installerCompanies;
        }
        dispatch({
          type: INSTALLER_COMPANIES_SUCCESS,
          installerCompanies: installerCompanies
        });
      }
    });
  };
}

export function loadProducts() {
  return dispatch => {
    dispatch({
      type: PRODUCTS_START
    });

    api.loadProducts(function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: PRODUCTS_ERROR,
            text: getErrorMessage('product.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: PRODUCTS_ERROR,
            text: getErrorMessage('product.load-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let products = [];
        if (res.body && res.body._embedded && res.body._embedded.products) {
          products = res.body._embedded.products;
        }
        dispatch({
          type: PRODUCTS_SUCCESS,
          products: products
        });
      }
    });
  };
}

export function changeTab(dispatch, tab) {
  dispatch({
    type: CHANGE_TAB,
    tab: tab
  });
}

export function loadSoftwareVersions() {
  return dispatch => {
    dispatch({
      type: SOFTWAREVERSIONS_START
    });

    api.loadSoftwareVersions(function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: SOFTWAREVERSIONS_ERROR,
            text: getErrorMessage('softwareversion.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: SOFTWAREVERSIONS_ERROR,
            text: getErrorMessage('softwareversion.load-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let softwareVersions = [];
        if (res.body && res.body._embedded && res.body._embedded.softwareVersions) {
          softwareVersions = res.body._embedded.softwareVersions;
        }
        dispatch({
          type: SOFTWAREVERSIONS_SUCCESS,
          softwareVersions: softwareVersions
        });
      }
    });
  };
}

export function addInstallerCompany(installer, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANY_ADD_START
    });

    api.addInstallerCompany(installer, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANY_ADD_ERROR,
            text: getErrorMessage('installer-company.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else if (err.status === 409) {
          dispatch({
            type: INSTALLER_COMPANY_ADD_ERROR,
            text: getErrorMessage('installer-company.duplicate'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANY_ADD_ERROR,
            text: getErrorMessage('installer-company.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_COMPANY_ADD_SUCCESS
        });
        dispatch({
          type: INSTALLER_COMPANY_ADD_ERROR,
          text: getErrorMessage('installer-company.add-success'),
          level: 'error',
          timeout: 8000
        });
      }

      callback(err);
    });
  };
}

export function addProduct(product, callback) {
  return dispatch => {
    dispatch({
      type: PRODUCT_ADD_START
    });

    api.addProduct(product, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: PRODUCT_ADD_ERROR,
            text: getErrorMessage('product.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: PRODUCT_ADD_ERROR,
            text: getErrorMessage('binary.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: PRODUCT_ADD_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function addSoftwareVersion(swVersion, callback) {
  return dispatch => {
    dispatch({
      type: SOFTWAREVERSION_ADD_START
    });

    api.addSoftwareVersion(swVersion, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: SOFTWAREVERSION_ADD_ERROR,
            text: getErrorMessage('softwareversion.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else if (err.status === 406) {
          dispatch({
            type: SOFTWAREVERSION_ADD_ERROR,
            text: getErrorMessage('softwareversion.duplicate'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: SOFTWAREVERSION_ADD_ERROR,
            text: getErrorMessage('softwareversion.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: SOFTWAREVERSION_ADD_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function updateInstallerCompany(installerCompany, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANY_UPDATE_START
    });

    api.updateInstallerCompany(installerCompany, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANY_UPDATE_ERROR,
            text: getErrorMessage('installer-company.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else if (err.status === 406) {
          dispatch({
            type: INSTALLER_COMPANY_UPDATE_ERROR,
            text: getErrorMessage('installer-company.conflict'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANY_UPDATE_ERROR,
            text: getErrorMessage('installer-company.update-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_COMPANY_UPDATE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function updateProduct(product, callback) {
  return dispatch => {
    dispatch({
      type: PRODUCT_UPDATE_START
    });

    api.updateProduct(product, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: PRODUCT_UPDATE_ERROR,
            text: getErrorMessage('product.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: PRODUCT_UPDATE_ERROR,
            text: getErrorMessage('product.update-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: PRODUCT_UPDATE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function updateSoftwareVersion(swVersion, callback) {
  return dispatch => {
    dispatch({
      type: SOFTWAREVERSION_UPDATE_START
    });

    api.updateSoftwareVersion(swVersion, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: SOFTWAREVERSION_UPDATE_ERROR,
            text: getErrorMessage('softwareversion.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: SOFTWAREVERSION_UPDATE_ERROR,
            text: getErrorMessage('softwareversion.update-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: SOFTWAREVERSION_UPDATE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function updateInstallerCompanyPassword(user, password, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANY_PASSWORD_START
    });

    api.updatePassword(user.username, password, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANY_PASSWORD_ERROR,
            text: getErrorMessage('installer-company.password-change.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANY_PASSWORD_ERROR,
            text: getErrorMessage('installer-company.password-change.failed') + err.response.text,
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_COMPANY_PASSWORD_SUCCESS,
          text: getErrorMessage('installer-company.password-change.success'),
          level: 'info'
        });
        callback();
      }
    });
  };
}

export function loadCommercialOffers() {
  return dispatch => {
    dispatch({
      type: COMMERCIAL_OFFERS_START
    });

    api.loadCommercialOffers(function(err, res) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: COMMERCIAL_OFFERS_ERROR,
            text: getErrorMessage('commercial-offer.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: COMMERCIAL_OFFERS_ERROR,
            text: getErrorMessage('commercial-offer.load-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let commercialOffers = [];
        if (res.body && res.body._embedded && res.body._embedded.commercialOffers) {
          commercialOffers = res.body._embedded.commercialOffers;
        }
        dispatch({
          type: COMMERCIAL_OFFERS_SUCCESS,
          commercialOffers: commercialOffers
        });
      }
    });
  };
}

export function loadFilterShops() {
  return dispatch => {
    dispatch({
      type: FILTER_SHOP_START
    });

    api.loadFilterShops(function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: FILTER_SHOP_ERROR,
            text: getErrorMessage('filtershop.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: FILTER_SHOP_ERROR,
            text: getErrorMessage('filtershop.load-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let filterShops = [];
        if (res.body && res.body._embedded && res.body._embedded.filterShops) {
          filterShops = res.body._embedded.filterShops;
        }
        dispatch({
          type: FILTER_SHOP_SUCCESS,
          filterShops: filterShops
        });
      }
    });
  };
}

export function saveCommercialOffer(offer, callback) {
  return dispatch => {
    dispatch({
      type: COMMERCIAL_OFFER_SAVE_START
    });

    api.saveCommercialOffer(offer, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: COMMERCIAL_OFFER_SAVE_ERROR,
            text: getErrorMessage('commercial-offer.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: COMMERCIAL_OFFER_SAVE_ERROR,
            text: getErrorMessage('commercial-offer.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: COMMERCIAL_OFFER_SAVE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function saveFilterShop(filterShop, callback) {
  return dispatch => {
    dispatch({
      type: FILTER_SHOP_SAVE_START
    });

    api.saveFilterShop(filterShop, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: FILTER_SHOP_SAVE_ERROR,
            text: getErrorMessage('filtershop.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: FILTER_SHOP_SAVE_ERROR,
            text: getErrorMessage('filtershop.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: FILTER_SHOP_SAVE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function disableInstallerCompany(installerCompany, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANY_DISABLE_START
    });

    api.disableInstallerCompany(installerCompany, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANY_DISABLE_ERROR,
            text: getErrorMessage('installer-company.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANY_DISABLE_ERROR,
            text: getErrorMessage('installer-company.removed-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_COMPANY_DISABLE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function disableProduct(product, callback) {
  return dispatch => {
    dispatch({
      type: PRODUCT_DISABLE_START
    });

    api.disableProduct(product, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: PRODUCT_DISABLE_ERROR,
            text: getErrorMessage('product.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: PRODUCT_DISABLE_ERROR,
            text: getErrorMessage('product.remove-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: PRODUCT_DISABLE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function deleteSoftwareVersion(swVersion, callback) {
  return dispatch => {
    dispatch({
      type: SOFTWAREVERSION_DELETE_START
    });

    api.deleteSoftwareVersion(swVersion, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: SOFTWAREVERSION_DELETE_ERROR,
            text: getErrorMessage('softwareversion.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: SOFTWAREVERSION_DELETE_ERROR,
            text: getErrorMessage('softwareversion.remove-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: SOFTWAREVERSION_DELETE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function uploadFile(datatype, data, name, productId, version, country) {
  return dispatch => {
    dispatch({
      type: UPLOAD_START,
      datatype: datatype
    });

    api.uploadFile(datatype, data, name, productId, version, country, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: UPLOAD_ERROR,
            text: getErrorMessage('binary.file-upload-no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: UPLOAD_ERROR,
            text: getErrorMessage('binary.file-upload-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: UPLOAD_SUCCESS,
          datatype: datatype,
          //text: 'De data is succesvol verwerkt',
          level: 'info',
          timeout: 5000
        });
      }
    });
  };
}

export function loadManager(id) {
  return dispatch => {
    dispatch({
      type: LOAD_MANAGER_START
    });

    api.loadManager(id, function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: LOAD_MANAGER_ERROR,
            text: getErrorMessage('manager.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: LOAD_MANAGER_ERROR,
            text: getErrorMessage('manager.load-fail'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let manager = {};
        if (res.body) {
          manager = res.body;
        }
        dispatch({
          type: LOAD_MANAGER_SUCCESS,
          manager: manager
        });
      }
    });
  };
}

export function loadDocuments(country) {
  return dispatch => {
    dispatch({
      type: LOAD_DOCUMENTS_START
    });

    api.loadDocuments(country, function(err, res) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: LOAD_DOCUMENTS_ERROR,
            text: getErrorMessage('documents.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: LOAD_DOCUMENTS_ERROR,
            text: getErrorMessage('documents.load-fail'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let documents = {};
        if (res.body) {
          documents = res.body;
        }
        dispatch({
          type: LOAD_DOCUMENTS_SUCCESS,
          documents: documents
        });
      }
    });
  };
}

export function changeDocumentPosition(oldIndex, newIndex) {
  return dispatch => {
    dispatch({
      type: CHANGE_DOCUMENT_POSITION_START
    });

    api.changeDocumentPosition(oldIndex, newIndex, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: CHANGE_DOCUMENT_POSITION_ERROR,
            text: getErrorMessage('documents.no-access'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        //let documents = {};
        //if (res.body) {
        //    documents = res.body;
        //}
        dispatch({
          type: CHANGE_DOCUMENT_POSITION_SUCCESS
          //documents: documents
        });
      }
    });
  };
}

export function addDocument(document, callback) {
  return dispatch => {
    dispatch({
      type: DOCUMENT_ADD_START
    });

    api.addDocument(document, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: DOCUMENT_ADD_ERROR,
            text: getErrorMessage('documents.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: DOCUMENT_ADD_ERROR,
            text: getErrorMessage('documents.add-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: DOCUMENT_ADD_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function removeDocument(document, callback) {
  return dispatch => {
    dispatch({
      type: DOCUMENT_DELETE_START
    });

    api.removeDocument(document, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: DOCUMENT_DELETE_ERROR,
            text: getErrorMessage('documents.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: DOCUMENT_DELETE_ERROR,
            text: getErrorMessage('document.remove-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: DOCUMENT_DELETE_SUCCESS
        });
      }

      callback(err);
    });
  };
}



// WEBPACK FOOTER //
// /src/actioncreators/ZehnderActions.js